import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { appRoutes } from '../../../routes/routes';
import { subscribeToQBStatus } from '../../../services/quickbooks';
import styles from './QuickBooksTile.module.scss';

export const QuickBooksTile = () => {
  const companyId = useSelector(
    (s) => s.auth.profile?.activeCompany?.companyId
  );
  const history = useHistory();

  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    const unsub = subscribeToQBStatus(companyId, (status) =>
      setConnected(status.connected)
    );
    return unsub;
  }, [companyId]);

  return (
    <div
      className={styles.tile}
      onClick={() => history.push(appRoutes().integrationsQuickBooks)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) =>
        e.key === 'Enter' && history.push(appRoutes().integrationsQuickBooks)
      }
    >
      <div className={styles.logo}>QB</div>
      <div className={styles.body}>
        <div className={styles.titleRow}>
          <span className={styles.name}>QuickBooks Online</span>
          <span
            className={`${styles.badge} ${connected ? styles.connected : styles.disconnected}`}
          >
            {connected ? 'Connected' : 'Not Connected'}
          </span>
        </div>
        <p className={styles.description}>
          Export tracked time to QuickBooks Online as time activities for
          payroll and billing.
        </p>
      </div>
      <div className={styles.arrow}>›</div>
    </div>
  );
};
